/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Text, Box } from '@tishman/components';
import React, { Fragment } from 'react';

import { CreditCardDisplayNames } from '../../../services/viva/constants';
import { stateAbbreviations } from '../../../buy-tickets/constants/constants';
import { selectOrder, selectPayment, useAppSelector } from '../../../store';

import type { CheckoutOrderPayment } from '../../../store/types';

const textStyle = { lineHeight: 'body', fontSize: 5 };

export const Contact = (): React.JSX.Element | null => {
  const order = useAppSelector(selectOrder);
  const _payment = useAppSelector(selectPayment);
  const payment = _payment as CheckoutOrderPayment;

  if (!order.account.accountAKs || !payment || !payment.creditCard) return null;

  return (
    <Box sx={{ mt: 5 }}>
      <Text sx={{ marginBottom: 3 }} variant="rockCenterPageName">
        Contact Billing
      </Text>
      <Text className="data-hj-suppress" sx={textStyle} variant="largeP">
        {order.account.name}
      </Text>
      <Text className="data-hj-suppress" sx={textStyle} variant="largeP">
        {order.account.email}
      </Text>
      {Boolean(order.account.mobileNumber) && (
        <Text className="data-hj-suppress" sx={textStyle} variant="largeP">
          {order.account.mobileNumber}
        </Text>
      )}
      {payment?.creditCard && (
        <Text className="data-hj-suppress" sx={textStyle} variant="largeP">
          {CreditCardDisplayNames[payment.creditCard.type]}
          {payment.creditCard.suffix}
        </Text>
      )}
      {payment?.address && (
        <Fragment>
          <Text className="data-hj-suppress" sx={textStyle} variant="largeP">
            {payment.address.street}
          </Text>
          <Text className="data-hj-suppress" sx={textStyle} variant="largeP">
            {payment.address.city}
            {payment.address.state && (
              <Fragment>
                , {stateAbbreviations.get(payment.address.state)}
              </Fragment>
            )}
            <Text> {payment.address.zip}</Text>
          </Text>
          <Text className="data-hj-suppress" sx={textStyle} variant="largeP">
            {payment.address.country}
          </Text>
        </Fragment>
      )}
    </Box>
  );
};
